import * as React from 'react';
import classnames from 'classnames';
import { Col } from 'react-grid-system';
import styles from './ColItem.styl';
const ColItem = ({ children, border, transparent, ...props }) => (React.createElement(Col, { ...props, className: styles.col },
    React.createElement("div", { className: classnames(styles.item, { [styles.borderItem]: border }, { [styles.backgroundItem]: !transparent }) }, children)));
export default ColItem;
